import Model, {
  attr,
  belongsTo,
  hasMany,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type ItemModel from './item';
import type SupplierModel from './supplier';
import type UserModel from './user';
import type OrderEntryModel from './order-entry';
import { action } from '@ember/object';

export default class SupplierItemModel extends Model {
  declare [Type]: 'supplier-item';
  @belongsTo('supplier', { async: false, inverse: 'supplierItems' })
  declare supplier: SupplierModel;
  declare supplier_init?: SupplierModel;

  @belongsTo('item', { async: false, inverse: 'supplierItems' })
  declare item: ItemModel;

  @attr('number')
  declare price: number;
  @attr()
  declare articlenr?: string;
  @attr('number')
  declare standard_order: number;
  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;
  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare updated_by: UserModel;

  @hasMany('order-entry', { async: false, inverse: 'supplier_item' })
  declare orderEntries: SyncHasMany<OrderEntryModel>;

  @action
  updateSupplier(supl: SupplierModel) {
    this.supplier_init = this.supplier_init
      ? this.supplier_init
      : this.supplier;
    this.supplier = supl;
  }
  get shouldBeSaved() {
    if (this.hasDirtyAttributes) {
      return true;
    } else {
      if (this.supplier != this.supplier_init) {
        return true;
      } else {
        return false;
      }
    }
  }
  @action rollback() {
    this.rollbackAttributes();
    if (this.supplier_init) {
      this.supplier = this.supplier_init;
    }
  }
}
